function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#929fb0",
  d: "M15 17a1 1 0 101 1 1 1 0 00-1-1zm-6 0H6a1 1 0 000 2h3a1 1 0 000-2zm9 0a1 1 0 101 1 1 1 0 00-1-1zm-3-6a1 1 0 101 1 1 1 0 00-1-1zm-6 0H6a1 1 0 000 2h3a1 1 0 000-2zm9-6a1 1 0 101 1 1 1 0 00-1-1zm0 6a1 1 0 101 1 1 1 0 00-1-1zm4-6a3 3 0 00-3-3H5a3 3 0 00-3 3v2a3 3 0 00.78 2A3 3 0 002 11v2a3 3 0 00.78 2A3 3 0 002 17v2a3 3 0 003 3h14a3 3 0 003-3v-2a3 3 0 00-.78-2 3 3 0 00.78-2v-2a3 3 0 00-.78-2A3 3 0 0022 7zm-2 14a1 1 0 01-1 1H5a1 1 0 01-1-1v-2a1 1 0 011-1h14a1 1 0 011 1zm0-6a1 1 0 01-1 1H5a1 1 0 01-1-1v-2a1 1 0 011-1h14a1 1 0 011 1zm0-6a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h14a1 1 0 011 1zm-5-2a1 1 0 101 1 1 1 0 00-1-1zM9 5H6a1 1 0 000 2h3a1 1 0 000-2z"
});

var SvgServer = function SvgServer(props) {
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgServer;